import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function postSchedule(schedule: Schedule) {
  // check for availabilities to be empty
  const nextSchedule = schedule.reduce((prev, curr) => {
    if (curr.available_intervals.length === 0) {
      return prev;
    }
    return [...prev, curr];
  }, [] as Schedule);

  const res = await fetchOrchidAPI(
    "/api/scheduler/v1/orchid_pro/available_time_periods",
    {
      headers: { "content-type": "application/json" },
      body: JSON.stringify(nextSchedule),
      method: "POST",
    },
  );
  if (!res.ok) {
    throw new Error(
      `failed to set schedule: ${getErrorDetail(await res.text())}`,
    );
  }
  return nextSchedule;
}
